export default __webpack_public_path__ + "static/media/eighteen.dfd7982f.jpeg";